import React, { useState ,useEffect } from 'react';

//src image
import banner from '../img/banner.png';
import logo from '../img/mulogo.png';

//css
import '../css/index.css';

//local store
import { useDispatch} from 'react-redux'
import { connect } from "react-redux";

//Useraction

import { useNavigate } from 'react-router-dom';
import { RiLogoutBoxLine ,RiCheckboxCircleFill,RiCloseCircleFill} from "react-icons/ri";
import { matchRoutes, useLocation } from "react-router-dom"
import Header from './header/Header';
import NavBtn from '../Nav/NavBtn';
import { Image } from '../img';
import {Utility} from '../Utility/Utility';

// import { RiLogoutBoxLine } from "react-icons/ri";

const TakingAttendance = (props) => {
    const currentLocation = useLocation();
    
    const dispatch=useDispatch();
    
    const navigate = useNavigate();
    const matches = matchRoutes(Utility.routes, currentLocation);
    console.log('matches',matches)
    const rightIconAry=[
        {
            icon:'How_dark',
            label: 'How to access OLE',
            path:'/how_to_access_ole',
        },
        {
            icon:'Dashboard_light',
            label: 'Dashboard',
            path:'/ashboard'
        },
        {
            icon:'Course_light',
            label: 'Course Page',
            path:'/course_page',
        },
        {
            icon:'Attendance_light',
            label: 'Taking Attendance',
            path:'/taking_attendance'
        },
        {
            icon:'Assignment_light',
            label: 'Assignment',
            path:'/assignment',
        },
        {
            icon:'Zoom_light',
            label: 'Zoom Recording',
            path:'/zoom_recording',
        },
        {
            icon:'Teaching_light',
            label: 'Teaching Tools',
            path:'/teaching_tools',
        }
    ]


    return (
        <div className='MainContainer'>
            <Header/>
            <div className={'MainContent'}>
                <img className='MainContentFixBottomImageOnly' src={Image.inner_pages_bg1} alt='banner'/>
                <div className='MainContentFixBottomLine'></div>
                <div className={'MainContentBox'}>
                    <img className="MainContentTopImage" src={Image.Sub_attendance} alt='banner' />
                    <div className="MainContentTopContain">
                        <span className="MainContentTopText">Taking Attendance</span>
                    </div>
                    <div className={"MainContentMiddleDetail"} >
                        <div style={{verticalAlign: 'middle',display: 'table-cell'}}>
                        <p >
                                    <span>Attendance can be taken in two ways. 
                                    </span>
                                </p>
                                <p >
                                    <span>
                                    
                                    </span>
                                </p>
                                
                                <br/>
                                    <b>
                                    <span className='subtitle'>Using a QR code / iBookcase</span>
                                    </b>
                                    <span>
                                    
                                    </span>
                                
                                <p >
                                    <b>
                                    <span>Lecturers and tutors to take attendance using a QR code 
                                    </span>
                                    </b>
                                </p>
                                <p >
                                    <span>To set up a QR code activity, click the ‘Class activities (Staff only)’ icon from the menu bar and follow these steps: 
                                    </span>
                                </p>
                                <ol>
                                    <li>
                                        <p >
                                            
                                            <span>Select the lecture group or tutorial group of your class. 
                                            </span>
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                        
                                            <span>Select the date/time. 
                                            </span>
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            
                                            <span>For ‘Session’, select ‘Normal’. 
                                            </span>
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <span>For the field ‘Type of activity’, select ‘Take attendance by scanning QR Code’. 
                                            </span>
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            
                                            <span>Click ‘Save &amp; Continue’. <br/>
                                            </span>
                                            <span >
                                            <a href={Image.Word.image023} data-lightbox="TakingAttendance" >
                                            <img border={0} width={500} height={'auto'} src={Image.Word.image023} />
                                            </a>
                                            </span>
                                            <span>
                                            
                                            </span>
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            
                                            <span>Select ‘Schedule start date/time’. 
                                            </span>
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            
                                            <span>Select ‘Open duration’. 
                                            </span>
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            
                                            <span>Click ‘Update’. <br/>
                                            </span>
                                            <span >
                                            <a href={Image.Word.image025} data-lightbox="TakingAttendance" >
                                            <img border={0} width={400} height={'auto'} src={Image.Word.image025} />
                                            </a>
                                            </span>
                                            <span>
                                            
                                            </span>
                                        </p>
                                    </li>
                                    <li>
                                        <p >
                                            
                                            <span>A QR code will appear on the screen. Show it to the students. <br/>
                                            </span>
                                            <span >
                                            <a href={Image.Word.image027} data-lightbox="TakingAttendance" >
                                            <img border={0} width={300} height={'auto'} src={Image.Word.image027}/>
                                            </a>
                                            </span>
                                            <span>
                                            
                                            </span>
                                        </p>
                                    </li>
                                </ol>
                                <p >
                                    <span>Schedule class activities for all upcoming classes: 
                                    </span>
                                </p>
                                <ol>
                                    <li>
                                        <p>
                                            <span>Select the group and date/time. 
                                            </span>
                                        </p>
                                    </li>
                                    <li>
                                        <p >
                                            
                                            <span>Click ‘Schedule for upcoming classes’. 
                                            </span>
                                        </p>
                                    </li>
                                    <li>
                                        <p >
                                            
                                            <span>For ‘Session’, select ‘Normal’. 
                                            </span>
                                        </p>
                                    </li>
                                    <li>
                                        <p >
                                            
                                            <span>Check ‘Auto start activity during class time’. 
                                            </span>
                                        </p>
                                    </li>
                                    <li>
                                        <p >
                                            
                                            <span>Set the open duration. 
                                            </span>
                                        </p>
                                    </li>
                                    <li>
                                        <p >
                                        
                                            <span>Click ‘Save &amp; Continue’. 
                                            </span>
                                        </p>
                                    </li>
                                </ol>
                                <p >
                                    <span >
                                    <a href={Image.Word.image029} data-lightbox="TakingAttendance" >
                                        <img border={0} width={650} height={'auto'} src={Image.Word.image029}/>
                                    </a>
                                    </span>
                                   
                                </p>
                                
                                <br/>
                                <p >
                                    
                                    <span className='subtitle'>
                                        Students to record their attendance 
                                    </span>
                                    
                                </p>
                                <ol>
                                    <li>
                                        <p >
                                            
                                            <span>Students can scan the QR code shown by the teaching staff </span>
                                            <span>to record their attendance. <br/>
                                            </span>
                                            <span >
                                            <a href={Image.Word.image031} data-lightbox="TakingAttendance" >
                                                <img border={0} width={198} height={'auto'} src={Image.Word.image031}/>
                                            </a>
                                            </span>
                                            <span>
                                            
                                            </span>
                                        </p>
                                    </li>
                                    <li>
                                        <p >
                                            
                                            <span>Alternatively, students can open the iBookcase app and tap on the ‘Class Activities’ link to view the current activity. In this case, they are not required to scan the QR Code. Instead, they will see a check mark which indicates their </span>
                                            <span  >attendance. <br/>
                                            </span>
                                            <span >
                                            <a href={Image.Word.image033} data-lightbox="TakingAttendance" >
                                                <img border={0} width={250} height={'auto'} src={Image.Word.image033}/>
                                            </a>
                                            </span>
                                            
                                            
                                            <span >
                                            <a href={Image.Word.image035} data-lightbox="TakingAttendance" >
                                                <img border={0} width={250} height={'auto'} src={Image.Word.image035}/>
                                            </a>
                                            </span>
                                            <span>
                                            <br />
                                            
                                            
                                            </span>
                                        </p>
                                    </li>
                                </ol>
                                <p>
                                    <span>We are currently developing a new method for attendance taking using Beacon technology. This will be launched in the 2023 Autumn Term. Please stay tuned for our announcement.</span>
                                    <span>
                                    
                                    </span>
                                </p>
                                
                                <br/><br/>
                                <b>
                                    
                                    <span className='subtitle'>Using in-class activities</span>
                                    
                                    <span>
                                    
                                    </span>
                                </b>
                                <p >
                                    <span>To set up in-class activities for attendance taking, follow the steps for using a QR Code, but this time select ‘Link with quiz/polling’ in the ‘Type of activity’ field. If a student participated in an activity, it can be assumed that they attended the class. 
                                    </span>
                                </p>
                                <p >
                                    <span>
                                    
                                    </span>
                                </p>
                                {false&&
                                <p >
                                    <span>For more information on setting up class activities, please refer to <a className='TakingAttendancePre'>here.</a>
                                    </span>
                                    
                                   
                                </p>
                                }
                        </div>
                    </div>
                    <NavBtn prevItem='/course-page' nextItem='/assignment'/>
                </div>
                
            </div>
            
            
        </div>
    )
};
  

const mapStateToProps =(state)=> {
    const {userInfo}=state;
    return {
        userInfo
    }
}

// export default CoursePage;
export default connect(mapStateToProps)(TakingAttendance);